var BASE_TAG_KEY = 'tag';
var tagKeys = {
  allTags: [BASE_TAG_KEY],
  tagSearch: function tagSearch(search) {
    return [BASE_TAG_KEY, search];
  }
};
export default tagKeys;